<div><div v-if="data"><div v-for="verse in data.verses" :key="verse.index"><b>{{verse.index}}&nbsp;</b><span>{{verse.content}}</span></div></div></div>